<template>
  <div>
    <h3>MCP Токены</h3>
    <p class="text-muted small">
      Токены позволяют MCP-серверам обращаться к API без сессионной куки. Значение токена показывается только один раз при создании.
    </p>

    <div v-if="newToken" class="alert alert-success">
      <strong>Токен создан. Сохраните его — он больше не будет показан.</strong>
      <div class="input-group mt-2">
        <input type="text" class="form-control form-control-sm font-monospace" readonly :value="newToken" ref="tokenInput">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btn-sm" @click="copyToken">{{ copied ? 'Скопировано' : 'Копировать' }}</button>
        </div>
      </div>
    </div>

    <table v-if="tokens.length" class="table table-sm mb-3">
      <thead>
        <tr>
          <th>Название</th>
          <th>Создан</th>
          <th>Последнее использование</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="token in tokens" :key="token.id">
          <td>{{ token.name || '—' }}</td>
          <td>{{ formatDate(token.createdAt) }}</td>
          <td>{{ token.lastUsedAt ? formatDate(token.lastUsedAt) : '—' }}</td>
          <td class="text-right">
            <button class="btn btn-outline-danger btn-sm" @click="deleteToken(token.id)">Удалить</button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="text-muted">Токены не созданы.</p>

    <form @submit.prevent="createToken">
      <div class="input-group">
        <input type="text" v-model="newName" class="form-control" placeholder="Название токена (необязательно)" maxlength="255">
        <div class="input-group-append">
          <button type="submit" class="btn btn-primary" :disabled="creating">Создать токен</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import repository from '@/repository/McpTokenRepository';

export default {
  name: 'McpTokens',
  data() {
    return {
      tokens: [],
      newName: '',
      newToken: null,
      copied: false,
      creating: false,
    };
  },
  created() {
    this.loadTokens();
  },
  methods: {
    loadTokens() {
      repository.list((data) => {
        this.tokens = data;
      });
    },
    createToken() {
      this.creating = true;
      this.newToken = null;
      this.copied = false;
      repository.create({ name: this.newName }, (data) => {
        this.newToken = data.token;
        this.newName = '';
        this.creating = false;
        this.loadTokens();
      }, () => {
        this.creating = false;
      });
    },
    deleteToken(id) {
      repository.remove(id, () => {
        this.tokens = this.tokens.filter(t => t.id !== id);
      });
    },
    copyToken() {
      navigator.clipboard.writeText(this.newToken).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      });
    },
    formatDate(timestamp) {
      return new Date(timestamp * 1000).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>
